import React, { useState, useContext, useEffect } from "react";
import cn from "classnames";
import styles from "./ImagesAndCTA.module.sass";
import Card from "../../../components/Card";
import File from "../../../components/File";
import './Variations.css'
import TextInput from "../../../components/TextInput";
import { createCategory, createSubCategory, getCategoryById, updateCatgory, uploadFile, getSubCategoryById, updateSubCatgory } from "../../../Firebase/firebaseDatabase";
import { GlobalState } from "../../../App";
import LoadingDialog from "../../../LoadingScreen/LoadingDialog";
import { validate_if_not_empty } from "../../../utils/extensions";
import LoadingIndicator from "../../../LoadingScreen/LoadingIndicator";
import Icon from "../../../components/Icon";
import { useHistory } from "react-router-dom";


const ImagesAndCTA = ({ className }) => {

  let history = useHistory();

  const [titleEn, setTitleEn] = useState()
  const [titleAr, setTitleAr] = useState()
  const [image, setImage] = useState()

  const [isEditForm, setIsEditForm] = useState(false)
  const [categoryId, setCategoryId] = useState()
  const [subCategoryId, setSubCategoryId] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [dateCreated, setDateCreated] = useState()


  const {
    isClicked, setIsClicked,
    isActionComplete, setIsActionComplete
  } = useContext(GlobalState)

  const handleChangeFiles = () => {
    const id = document.getElementById('subCategoryCoverImg');
   // console.log("files: ", id.files[0])
    setImage(id.files[0])
  }

  const subCategoryObj = {
    id: subCategoryId ?? '',
    dateCreated: dateCreated ?? '',
    dateEdited: '',
    titleAr: titleAr ?? '',
    titleEn: titleEn ?? '',
    status: '',
    image: image ?? ''
  }

  const getSubCategoryDetails = async (catId, subCatId) => {
    try {
      const details = await getSubCategoryById(catId, subCatId)
     // console.log("category details: ", details)
      if (details !== undefined && details !== '') {
        setTitleEn(details[0]?.data?.titleEn)
        setTitleAr(details[0]?.data?.titleAr)
        setImage(details[0]?.data?.image)
        setDateCreated(details[0]?.data?.dateCreated)
        setTimeout(() => {
          setIsLoading(false)
        }, 1000);

      }
    } catch (error) {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // setIsLoading(true)
    const checkFormType = window.location.pathname.split("/")[5]
   // console.log("path: ", checkFormType)

    if (checkFormType === "edit") {
      setIsEditForm(true);
      setIsLoading(true);
      setCategoryId(window.location.pathname.split("/")[3])
      setSubCategoryId(window.location.pathname.split("/")[4])
      getSubCategoryDetails(window.location.pathname.split("/")[3], window.location.pathname.split("/")[4])
    }
    if (checkFormType !== "edit") {
     // console.log("id:", window.location.pathname.split("/")[2])
      setCategoryId(window.location.pathname.split("/")[3])
    }
  }, [])

  useEffect(() => {
    setIsClicked(false)
    setIsActionComplete(false)
  }, []);

  useEffect(() => {
   // console.log("category id when updated: ", categoryId)
  }, [isClicked, isActionComplete, categoryId]);

  useEffect(() => {

  }, [isLoading])


  return (
    <Card
      className={cn(styles.card, className)}
      title="Category Details"
      classTitle="title-green"
      head={
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>

          <button className={cn("button", styles.backButton)} onClick={() => history.goBack()} >
            <Icon name="arrow-left" size={20} fill="black" />
            <span>Back</span>
          </button>
          <button
            onClick={async () => {
              setIsClicked(true)
              subCategoryObj.titleAr = titleAr;
              subCategoryObj.titleEn = titleEn;
              if (!isEditForm) {
                if (
                  validate_if_not_empty(titleEn, "subCategoryTitleEnErrId") &&
                  validate_if_not_empty(titleAr, "subCategoryTitleArErrId") &&
                  validate_if_not_empty(image, "subCategoryCoverImgErrId")
                ) {
                  const imageUrl = await uploadFile(image, "subCategory")
                  subCategoryObj.image = imageUrl;
                 // console.log("categry id: ", categoryId)
                  createSubCategory(categoryId, subCategoryObj, setIsClicked, setIsActionComplete)
                } else {
                  setIsClicked(false)
                }

              } else {
                if (subCategoryObj?.image?.toString().includes("https")) {
                 // console.log(subCategoryObj)
                  updateSubCatgory(categoryId, subCategoryObj, setIsClicked, setIsActionComplete)
                } else {
                  const imageUrl = await uploadFile(image, "category")
                  subCategoryObj.image = imageUrl;
                  updateSubCatgory(categoryId, subCategoryObj, setIsClicked, setIsActionComplete)
                }

              }

            }}
            className={cn("button", styles.button)} >
            <span>Save</span>
          </button>
        </div>

      }
    >
      {
        isClicked ?
          !isActionComplete ?
            <LoadingDialog /> : window.location.href = `/subCategory/${window.location.pathname.split("/")[2]}/${window.location.pathname.split("/")[3]}`
          : <></>
      }

      {
        isLoading ? <LoadingIndicator /> :

          <div className={styles.description}>

            <div className={styles.fieldset}>

              <div className={`${styles.fieldContainer}`}>
                <TextInput
                  className={styles.field}
                  classInput={styles.fieldInput}
                  label="Sub-Category Title (English)"
                  name="subCategoryTitleEn"
                  type="text"
                  onChange={(e) => { setTitleEn(e.target.value) }}
                  value={titleEn}
                />
                <p className={styles.errField} id="subCategoryTitleEnErrId"></p>

              </div>
            </div>

            <div className={styles.fieldset}>

              <div className={`${styles.fieldContainer}`}>
                <TextInput
                  className={styles.field}
                  classInput={styles.fieldInput}
                  label="Sub-Category Title (Arabic)"
                  name="subCategoryTitleEn"
                  type="text"
                  onChange={(e) => { setTitleAr(e.target.value) }}
                  value={titleAr}
                />
                <p className={styles.errField} id="subCategoryTitleArErrId"></p>
              </div>
            </div>

            <div className={styles.image_section}>

              <div className={styles.files}>
                <File
                  classInput={styles.imageInput}
                  className={styles.imageField}
                  classInputWraper={styles.imageFieldWrapper}
                  title={
                    image?.name !== '' && image?.name !== undefined ?
                      image?.name
                      : "Click or drop image"
                  }
                  id={`subCategoryCoverImg`}
                  label="Cover image"
                  onChange={() => handleChangeFiles()}
                  url={isEditForm ? image : ''}
                />
              </div>
              <p className={styles.errField} id="subCategoryCoverImgErrId"></p>
            </div>

          </div>
      }



    </Card>
  );
};

export default ImagesAndCTA;
